import { render, staticRenderFns } from "./TicketsFormulario.vue?vue&type=template&id=d950f3d8&"
import script from "./TicketsFormulario.vue?vue&type=script&lang=ts&"
export * from "./TicketsFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports